var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-resources-container", attrs: { id: "js-resources" } },
    [
      this.resources.length > 0 && this.step !== this.steps
        ? _c("div", { staticClass: "c-resources-basket" }, [
            _c("div", { staticClass: "c-resources-basket__container" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand c-resources__button",
                  on: { click: _vm.nextStep }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.renderViewOrderButtonText()) +
                      "\n    "
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "c-resources__header" }, [
          _vm.options.heading
            ? _c("h1", { staticClass: "c-resources__heading" }, [
                _vm._v("\n        " + _vm._s(_vm.options.heading) + "\n      ")
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-resources__stage-container" }, [
        _vm.options.showForm
          ? _c(
              "div",
              {
                staticClass: "c-resources__stage",
                class: this.step == 2 ? "is-active" : null
              },
              [
                _c("div", { staticClass: "grid-container" }, [
                  _c("div", { staticClass: "c-confirmation-message" }, [
                    _vm.formSuccess
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "\n              c-confirmation-message__content\n              c-confirmation-message__content--success\n            "
                          },
                          [
                            _c("div", { staticClass: "c-rte" }, [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.options.successTitle))
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.options.successMessage))
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.formError
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "\n              c-confirmation-message__content\n              c-confirmation-message__content--error\n            "
                          },
                          [
                            _c("div", { staticClass: "c-rte" }, [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.options.errorTitle))
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.options.errorMessage))
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm.options.showForm
                  ? _c("form-box", {
                      attrs: {
                        backButtonText: _vm.options.backButtonText,
                        submitButtonText: _vm.options.submitButtonText,
                        headingBlockOne: _vm.options.headingBlockOne,
                        headingBlockTwo: _vm.options.headingBlockTwo,
                        titleLabel: _vm.options.title,
                        otherTitleLabel: _vm.options.otherTitle,
                        emailLabel: _vm.options.email,
                        extraDetailsLabel: _vm.options.extraDetails,
                        firstNameLabel: _vm.options.firstName,
                        lastNameLabel: _vm.options.lastName,
                        numberLabel: _vm.options.number,
                        firstLineOfAddressLabel: _vm.options.firstLineOfAddress,
                        requestedItems: _vm.resources,
                        secondLineOfAddressLabel:
                          _vm.options.secondLineOfAddress,
                        summaryHeading: _vm.options.summaryHeading,
                        thirdLineOfAddressLabel: _vm.options.thirdLineOfAddress,
                        postcodeLabel: _vm.options.postcode,
                        title: _vm.formBoxData.title,
                        email: _vm.formBoxData.email,
                        extraDetails: _vm.formBoxData.extraDetails,
                        firstLineOfAddress: _vm.formBoxData.firstLineOfAddress,
                        firstName: _vm.formBoxData.firstName,
                        lastName: _vm.formBoxData.lastName,
                        number: _vm.formBoxData.number,
                        otherTitle: _vm.formBoxData.otherTitle,
                        postcode: _vm.formBoxData.postcode,
                        secondLineOfAddress:
                          _vm.formBoxData.secondLineOfAddress,
                        thirdLineOfAddress: _vm.formBoxData.thirdLineOfAddress,
                        emailValidationMessage:
                          _vm.options.emailValidationMessage,
                        extraDetailsValidationMessage:
                          _vm.options.extraDetailsValidationMessage,
                        firstLineOfAddressValidationMessage:
                          _vm.options.firstLineOfAddressValidationMessage,
                        firstNameValidationMessage:
                          _vm.options.firstNameValidationMessage,
                        lastNameValidationMessage:
                          _vm.options.lastNameValidationMessage,
                        numberValidationMessage:
                          _vm.options.numberValidationMessage,
                        otherTitleValidationMessage:
                          _vm.options.otherTitleValidationMessage,
                        postcodeValidationMessage:
                          _vm.options.postcodeValidationMessage,
                        secondLineOfAddressValidationMessage:
                          _vm.options.secondLineOfAddressValidationMessage,
                        thirdLineOfAddressValidationMessage:
                          _vm.options.thirdLineOfAddressValidationMessage,
                        titleValidationMessage:
                          _vm.options.titleValidationMessage
                      },
                      on: {
                        collateDetails: _vm.collateDetails,
                        prevStep: _vm.prevStep,
                        removeItem: _vm.removeItem,
                        updateQuantity: _vm.updateQuantity,
                        valueChange: _vm.formBoxValueChange
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-resources__stage",
            class: [
              this.step == 1 ? "is-active" : null,
              this.resources.length > 0 ? "has-fixed-button" : null
            ]
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "c-resources__subheading" }, [
                _vm.searchResultsText
                  ? _c(
                      "h2",
                      { staticClass: "c-resources__subheading__title" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.searchResultsText) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.options.expandFilters
                  ? _c(
                      "a",
                      {
                        class: [
                          _vm.showFilters
                            ? "c-expand-filters c-expand-filters--open"
                            : "c-expand-filters"
                        ],
                        attrs: { href: "#" },
                        on: { click: _vm.expandFilters }
                      },
                      [_vm._v(_vm._s(_vm.options.expandFilters.text))]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showFilters,
                    expression: "showFilters"
                  }
                ],
                staticClass: "c-resources"
              },
              [
                _c(
                  "div",
                  { staticClass: "c-resources__inner grid-container" },
                  [
                    _c("div", { staticClass: "c-resources__filters" }, [
                      _c(
                        "div",
                        { staticClass: "c-resources__column" },
                        [
                          _vm.options.sortByOptions
                            ? _c("drop-down", {
                                attrs: {
                                  filters: _vm.options.sortByOptions,
                                  "event-name": "updateSortBy"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.options.typeOptions
                            ? _c("drop-down", {
                                attrs: {
                                  filters: _vm.options.typeOptions,
                                  "event-name": "updateType"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "c-resources__column" },
                        [
                          _c("checkbox", {
                            attrs: { filters: _vm.options.filters }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "c-resources__btn-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass: "c-button c-button--brand",
                          attrs: { href: "#" },
                          on: { click: _vm.filterEventHandler }
                        },
                        [_vm._v(_vm._s(_vm.options.buttonText))]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "grid-container" }, [
              _c(
                "div",
                {
                  staticClass:
                    "c-resources__results c-resources__results-container"
                },
                _vm._l(_vm.results, function(result) {
                  return _c("resources-results-card", {
                    key: result.id,
                    attrs: {
                      result: result,
                      requestedButtonsText: _vm.requestedButtonsText,
                      requestedButtonsActiveText:
                        _vm.requestedButtonsActiveText,
                      requestedItems: _vm.resources,
                      showForm: _vm.options.showForm
                    },
                    on: { addItem: _vm.addItem, removeItem: _vm.removeItem }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _vm.options.noResults && _vm.results.length === 0
                ? _c("div", { staticClass: "c-resources__no-results" }, [
                    _c("p", [_vm._v(_vm._s(_vm.noResultsText))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.options.loadMoreText && _vm.pageNumber < _vm.totalPages
                ? _c("div", { staticClass: "c-resources__btn-container" }, [
                    _c(
                      "button",
                      {
                        staticClass: "c-button c-button--brand",
                        on: { click: _vm.loadMoreResultsHandler }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.options.loadMoreText) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7729f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7729f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/partnerhub/resources/Resources.vue
// module id = 538
// module chunks = 0